// useProgressMutations.js

import { useMutation, useQueryClient } from '@tanstack/react-query';
import ProgressService from '../Services/progress/ProgressService';
// import { toast } from 'sonner';

export const useProgressMutations = () => {
  const queryClient = useQueryClient();

  const markLessonAsCompletedMutation = useMutation({
    mutationFn: (lessonId) => ProgressService.markLessonAsCompleted(lessonId),
    onSuccess: (data) => {
      queryClient.invalidateQueries(); // Invalidate relevant queries
      // if (data.message === 'Lesson already completed') {
      //   toast.warning(data.message);
      // } else {
      //   toast.success(data.message);
      // }
    },
    onError: (error) => {
      // toast.error(`Échec de la validation de la leçon : ${error.message}`);
    },
  });

  const markExerciseAsCompletedMutation = useMutation({
    mutationFn: (exerciseId) => ProgressService.markExerciseAsCompleted(exerciseId),
    onSuccess: (data) => {
      queryClient.invalidateQueries(); // Invalidate relevant queries
      // if (data.message === 'Exercise already completed') {
      //   toast.warning(data.message);
      // } else {
      //   toast.success(data.message);
      // }
    },
    onError: (error) => {
      // toast.error(`Échec de la validation de l'exercice : ${error.message}`);
    },
  });

  return {
    markLessonAsCompletedMutation,
    markExerciseAsCompletedMutation,
  };
};